import React, { FC } from 'react';

import cx from 'classnames';

import Tooltip, { VARIANTS } from '../Tooltip';
import s from './index.module.css';
import { ILabelProps } from './types';
import { hexToRgb } from './utils';

export const Label: FC<ILabelProps> = ({ color, text, className, tooltip }) => {
  const commonLabel = (
    <span className={cx(s.label, className)} style={{ color, backgroundColor: hexToRgb(color, 0.15) }}>
      {text}
    </span>
  );

  return tooltip ? (
    <div className={s.labelWithTooltip} data-tip data-for="label-tooltip">
      {commonLabel}
      <Tooltip id="label-tooltip" className={s.tooltip} variant={VARIANTS.DARK}>
        {tooltip}
      </Tooltip>
    </div>
  ) : (
    commonLabel
  );
};
